import GoodCard from "./card"


export default function GoodsHorizontalList({ list })
{
    return (
        <div className="row">
            
            {
                list && list?.length > 0 && list.map((item,index) => {
                    return <GoodCard 
                        key={`card-${index}`}
                        item={item}
                        className={"col-lg-3 col-md-6 col-xs-100pc  m-b30"}
                    />
                })
            }
        </div>
    )
}